<span class="badge badge-pedido-status badge-pedido-status-em-analise">
    {{status.nome}}
</span>